/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    GeocodeAddress,
    GeocodeAddressFromJSON,
    GeocodeAddressFromJSONTyped,
    GeocodeAddressToJSON,
} from './GeocodeAddress';
import {
    Preferences,
    PreferencesFromJSON,
    PreferencesFromJSONTyped,
    PreferencesToJSON,
} from './Preferences';
import {
    ProgramType,
    ProgramTypeFromJSON,
    ProgramTypeFromJSONTyped,
    ProgramTypeToJSON,
} from './ProgramType';
import {
    TrafficSource,
    TrafficSourceFromJSON,
    TrafficSourceFromJSONTyped,
    TrafficSourceToJSON,
} from './TrafficSource';

/**
 * 
 * @export
 * @interface ProgramCreateParams
 */
export interface ProgramCreateParams {
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    member_title?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    name: string;
    /**
     * 
     * @type {Array<ProgramType>}
     * @memberof ProgramCreateParams
     */
    types: Array<ProgramType>;
    /**
     * 
     * @type {Preferences}
     * @memberof ProgramCreateParams
     */
    preferences?: Preferences;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    email?: string;
    /**
     * 
     * @type {GeocodeAddress}
     * @memberof ProgramCreateParams
     */
    address: GeocodeAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramCreateParams
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    language: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProgramCreateParams
     */
    default_currency?: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    timezone: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramCreateParams
     */
    items?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramCreateParams
     */
    source_token?: string;
    /**
     * 
     * @type {TrafficSource}
     * @memberof ProgramCreateParams
     */
    traffic_source?: TrafficSource;
}

export function ProgramCreateParamsFromJSON(json: any): ProgramCreateParams {
    return ProgramCreateParamsFromJSONTyped(json, false);
}

export function ProgramCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'member_title': !exists(json, 'member_title') ? undefined : json['member_title'],
        'name': json['name'],
        'types': ((json['types'] as Array<any>).map(ProgramTypeFromJSON)),
        'preferences': !exists(json, 'preferences') ? undefined : PreferencesFromJSON(json['preferences']),
        'website': !exists(json, 'website') ? undefined : json['website'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': GeocodeAddressFromJSON(json['address']),
        'tags': json['tags'],
        'language': json['language'],
        'default_currency': !exists(json, 'default_currency') ? undefined : CurrencyCodeFromJSON(json['default_currency']),
        'timezone': json['timezone'],
        'items': !exists(json, 'items') ? undefined : json['items'],
        'source_token': !exists(json, 'source_token') ? undefined : json['source_token'],
        'traffic_source': !exists(json, 'traffic_source') ? undefined : TrafficSourceFromJSON(json['traffic_source']),
    };
}

export function ProgramCreateParamsToJSON(value?: ProgramCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'member_title': value.member_title,
        'name': value.name,
        'types': ((value.types as Array<any>).map(ProgramTypeToJSON)),
        'preferences': PreferencesToJSON(value.preferences),
        'website': value.website,
        'email': value.email,
        'address': GeocodeAddressToJSON(value.address),
        'tags': value.tags,
        'language': value.language,
        'default_currency': CurrencyCodeToJSON(value.default_currency),
        'timezone': value.timezone,
        'items': value.items,
        'source_token': value.source_token,
        'traffic_source': TrafficSourceToJSON(value.traffic_source),
    };
}

